import { requestPost } from "../../../Helpers";
import { alertDialog, alertError, alertSuccess } from "../../../Helpers/Alerts";

/**
 * Delete an item from wishlist
 * @param {String} item_wishlist_product_id
 * @returns {Promise}
 * @example
 * deleteItem("item_wishlist_product_id").then((uuid) => console.log(uuid));
 */

export const deleteItem = (item_wishlist_product_id) => {

    if (!item_wishlist_product_id) {
        alertError("Falta información.", "Error al eliminar producto de la lista de deseos.");
        return;
    }

    const formData = new FormData();
    formData.append("product", item_wishlist_product_id);

    alertDialog("¿Estás seguro de eliminar este producto de tu lista de deseos?", "Eliminar producto de la lista de deseos", "warning")
        .then((result) => {
            console.log(result);
            if (result) {
                requestPost(`wishlist_items/delete_to_wishlistitem/`, formData)
                    .then((data) => {
                        alertSuccess("Producto eliminado de tu lista de deseos.", "Producto eliminado");
                        return data
                    });
            }
        })
        .catch((error) => {
            console.error(error);
            alertError("Error al eliminar producto de la lista de deseos.");
        });
    
}